<template>
  <div class="tq-person-selector-empty">
    <img src="../images/img_empty.png" alt="空数据" />
    <p class="empty-text">{{ text }}</p>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{ text: string; top?: number,unit?:string }>(), {
  top: 40,
  unit:'%'
});
const emptyTop:string = props.top + props.unit;
</script>

<style scoped>
.tq-person-selector-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: v-bind(emptyTop);
  transform: translate(-50%, -50%);
  img {
    width: 72px;
  }
  .empty-text {
    margin-top: 5px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #969696;
    letter-spacing: 0;
    font-weight: 400;
  }
}
</style>
